export const role_hierarchy: { [key: string]: string | string[] } = {
  // changes here need to be reflected in backend: security.yaml
  ROLE_ADMIN: ['ROLE_PATROL_MANAGER'],
  ROLE_PATROL_MANAGER: ['ROLE_USER'],
  ROLE_EXECUTIVE: ['ROLE_USER'],
  ROLE_PATROLLER: ['ROLE_USER'],
};
